export default {
    isAppWarning(state) {
        return state.appState === 'warning';
    },
};
